/* eslint-disable eqeqeq */
//Actions
const typeOrder = 'TYPE_ORDER'

//Reducer
export default function reducer(state = [], action) {
  switch(action.type) {
    case typeOrder: {
      return [ action.payload ]
    }
    default: {
      return state
    }
  }
}

//Action Creators
export const addToOrderWayAction = (data) => ({
  type: typeOrder,
  payload: {
    data
  }
})